import { searchUrl } from "@outschool/routes";
import { useIsMobile } from "@outschool/ui-utils";
import React from "react";

import {
  useSearchPageDescription,
  useSearchPageTitle
} from "../../shared/PageMetadata";
import HeaderTags from "../components/HeaderTags";
import SearchListings from "../components/search/desktop/Listings";
import MobileSearchListings from "../components/search/mobile/Listings";
import {
  SearchFiltersContextProvider,
  useSearchFilters
} from "../lib/useSearchFilters";

function SearchListingsWithMetaTags() {
  const isMobile = useIsMobile();
  const { filters } = useSearchFilters();
  // @ts-ignore TS(2345): Argument of type 'ExtendedSearchFiltersType | unde... Remove this comment to see the full error message
  const title = useSearchPageTitle(filters);
  // @ts-ignore TS(2532): Object is possibly 'undefined'.
  const description = useSearchPageDescription(filters.theme);
  const metaTags = [
    {
      name: "description",
      content: description
    },
    { property: "og:title", content: title },
    { property: "og:description", content: description }
  ];
  const link = [{ rel: "canonical", href: searchUrl() }];

  return (
    <>
      <HeaderTags title={title} meta={metaTags} link={link} />
      {isMobile ? <MobileSearchListings /> : <SearchListings />}
    </>
  );
}

export default function SearchListingsSwitcher() {
  return (
    <SearchFiltersContextProvider>
      <SearchListingsWithMetaTags />
    </SearchFiltersContextProvider>
  );
}
